import cashDeskInstance from '../instance'

const toggleClientMonitor = (state) => {
	return cashDeskInstance.post(`/clientMonitor/${state}`)
}

export default toggleClientMonitor
